module.exports = __webpack_public_path__ + "img/tutorial_three_en.cd8d9c26.png";